export default __webpack_public_path__ + "static/media/zyda-logo.59db566f.svg";